import { useMemo } from "react"

import { useTranslation } from "react-i18next"

import Table from "../../../../../Components/Table"
import { getColumns } from "../../ReceiptLookupTable/columns"

import styles from "./styles.module.less"

const buildGhostRows = () => {
  const now = Date.now()
  return Array.from({ length: 7 }, (_, i) => {
    const channel = i % 4 === 3 ? "call_center" : "banking_app"
    return {
      id: `ghost-${i}`,
      date: new Date(now - (i + 1) * 24 * 60 * 60 * 1000).toISOString(),
      card: String(2000 + i * 111).slice(-4),
      channel,
      program: i % 2 === 0 ? "cc" : "oi",
      amount: 50 + i * 45.75,
      fee_charged: null
    }
  })
}

// Reused behind NotEnrolledOverlay / PendingEnrollmentOverlay.
const GhostTable = ({ activeColumns }) => {
  const { t } = useTranslation()
  const columnMap = getColumns({ t })
  const ghostRows = useMemo(buildGhostRows, [])

  const cols = (activeColumns || Object.keys(columnMap).map((field_id) => ({ field_id })))
    .filter((c) => c.active !== false)
    .map((c) => columnMap[c.field_id])
    .filter(Boolean)

  return (
    <div className={styles.ghost} aria-hidden="true">
      <Table
        dataSource={ghostRows}
        columns={cols}
        rowKey="id"
        pagination={false}
        withOutPagination
      />
    </div>
  )
}

export default GhostTable
